
export type SortField = 'name' | 'type' | 'lastModified' | 'size';
export const NAME: SortField = 'name';
export const TYPE: SortField = 'type';
export const LAST_MODIFIED: SortField = 'lastModified';
export const SIZE: SortField = 'size';

export type SortDirection = 'asc' | 'desc';
export const ASC: SortDirection = 'asc';
export const DESC: SortDirection = 'desc';

export type DriveItemType = 'file' | 'folder';
export const FILE: DriveItemType = 'file';
export const FOLDER: DriveItemType = 'folder';

export interface DriveItem {
    name: string;
    type: DriveItemType;
    path: string;
    size: number | null;
    lastModified: string | null;
}

export interface DriveListResponse {
    items: DriveItem[];
}


export type FetchItemsFn = (path: string) => Promise<DriveItem[]>;